import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Badge = (props) => (
    <svg
        fill='none'
        height='32'
        viewBox='0 0 22 32'
        width='22'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M11 5.77216L16.5 8.84569V15.0625L11 18.136L5.5 15.0625V8.84569L11 5.77216ZM8 10.3125V13.5957L11 15.2722L14 13.5957V10.3125L11 8.63604L8 10.3125Z'
            fill='currentColor'/>
        <path
            d='M9.40321 0.41932C10.3943 -0.139773 11.6057 -0.139774 12.5968 0.41932L20.3468 4.79111C21.3682 5.3673 22 6.44907 22 7.62179V16.2857C22 17.4584 21.3682 18.5402 20.3468 19.1163L19 19.8761V29.2549C19 31.429 16.4782 32.6308 14.7896 31.2614L11 28.1884L7.21045 31.2614C5.52179 32.6308 3 31.429 3 29.2549V19.8761L1.65321 19.1163C0.63179 18.5402 0 17.4584 0 16.2857V7.6218C0 6.44907 0.631789 5.3673 1.65321 4.79111L9.40321 0.41932ZM5.5 21.2863V29.2549C5.5 29.2734 5.50252 29.2835 5.50383 29.2878C5.50524 29.2925 5.50698 29.296 5.50931 29.2996C5.51454 29.3075 5.52661 29.3202 5.54748 29.3302C5.56835 29.3401 5.58587 29.3414 5.5953 29.3405C5.5995 29.3401 5.60337 29.3392 5.60785 29.3374C5.61204 29.3357 5.6215 29.3313 5.63582 29.3197L11 24.9698L16.3642 29.3197C16.3785 29.3313 16.388 29.3357 16.3921 29.3374C16.3966 29.3392 16.4005 29.3401 16.4047 29.3405C16.4141 29.3414 16.4316 29.3401 16.4525 29.3302C16.4734 29.3202 16.4855 29.3075 16.4907 29.2996C16.493 29.296 16.4948 29.2925 16.4962 29.2878C16.4975 29.2835 16.5 29.2734 16.5 29.2549V21.2863L12.5968 23.4881C11.6057 24.0472 10.3943 24.0472 9.40321 23.4881L5.5 21.2863ZM11.3685 2.59677C11.1398 2.46774 10.8602 2.46774 10.6315 2.59677L2.88151 6.96856C2.6458 7.10153 2.5 7.35117 2.5 7.6218L2.5 16.2857C2.5 16.5563 2.6458 16.8059 2.88151 16.9389L10.6315 21.3107C10.8602 21.4397 11.1398 21.4397 11.3685 21.3107L19.1185 16.9389C19.3542 16.8059 19.5 16.5563 19.5 16.2857V7.62179C19.5 7.35117 19.3542 7.10153 19.1185 6.96856L11.3685 2.59677Z'
            fill='currentColor'/>
    </svg>
);

export default Badge;
